import React from "react";

export class PlanningBoundary extends React.Component {
    state = { failed: false, attempt: 0 };
    static getDerivedStateFromError() { return { failed: true }; }
    render() {
        if (this.state.failed) return <div role="alert" data-testid="planning-render-error" className="border border-red-500/40 p-5 text-sm text-red-400">
            Impossibile visualizzare il Planning. Gli altri menu restano disponibili.
            <button data-testid="planning-render-retry" className="block mt-3 border border-current px-4 py-2 hover:bg-red-500/10 transition-colors" onClick={() => this.setState(s => ({ failed: false, attempt: s.attempt + 1 }))}>Riprova</button>
        </div>;
        return <React.Fragment key={this.state.attempt}>{this.props.children}</React.Fragment>;
    }
}